import { Link } from "react-router-dom";
import Navbar from "@/components/feature/Navbar";
import Footer from "@/components/feature/Footer";
import Breadcrumb from "@/components/feature/Breadcrumb";
import SeoHead from "@/components/feature/SeoHead";

export default function AboutPage() {
  const breadcrumbItems = [
    { label: "首页", href: "/" },
    { label: "关于我们" },
  ];

  const webpageSchema = {
    "@context": "https://schema.org",
    "@type": "AboutPage",
    name: "关于我们 - 黑料在线",
    url: "http://lvepkfa.cn/about",
    description:
      "了解黑料在线的品牌故事、平台定位与联系方式。黑料在线是专业的娱乐爆料聚合平台。",
    isPartOf: {
      "@type": "WebSite",
      name: "黑料在线",
      url: "http://lvepkfa.cn/",
    },
  };

  const orgSchema = {
    "@context": "https://schema.org",
    "@type": "Organization",
    name: "黑料在线",
    url: "http://lvepkfa.cn/",
    logo: "http://lvepkfa.cn/logo.png",
    description: "专业的娱乐爆料聚合平台，每日精选全网热门八卦",
    foundingDate: "2023",
    sameAs: ["http://lvepkfa.cn/"],
    contactPoint: {
      "@type": "ContactPoint",
      contactType: "客户支持",
      email: "hello@lvepkfa.cn",
      availableLanguage: "Chinese",
    },
  };

  const breadcrumbSchema = {
    "@context": "https://schema.org",
    "@type": "BreadcrumbList",
    itemListElement: [
      {
        "@type": "ListItem",
        position: 1,
        name: "首页",
        item: "http://lvepkfa.cn/",
      },
      {
        "@type": "ListItem",
        position: 2,
        name: "关于我们",
        item: "http://lvepkfa.cn/about",
      },
    ],
  };

  return (
    <div className="min-h-screen bg-background-50">
      <SeoHead
        title="关于我们 - 黑料在线 | 品牌介绍与联系方式"
        description="了解黑料在线的品牌故事、平台定位与联系方式。黑料在线是专业的娱乐爆料聚合平台，致力于为吃瓜群众提供最新最全的在线看料入口。"
        keywords="黑料在线,关于我们,品牌介绍,联系方式,娱乐爆料平台"
        canonicalUrl="http://lvepkfa.cn/about"
        ogType="website"
        schema={[webpageSchema, orgSchema, breadcrumbSchema]}
      />

      <Navbar />

      <main className="pt-16 md:pt-20">
        {/* Header */}
        <div className="relative overflow-hidden">
          <div className="absolute inset-0">
            <img
              src="https://readdy.ai/api/search-image?query=Modern%20media%20newsroom%20with%20multiple%20screens%20and%20dramatic%20lighting%2C%20dark%20elegant%20atmosphere%2C%20red%20and%20gold%20accent%20lights%2C%20professional%20journalism%20workspace%2C%20cinematic%20photography%20with%20deep%20shadows%20and%20warm%20tones&width=1600&height=500&seq=about-hero&orientation=landscape"
              alt="关于黑料在线"
              className="w-full h-full object-cover object-top"
              width={1600}
              height={500}
            />
            <div className="absolute inset-0 bg-gradient-to-r from-black/70 via-black/50 to-black/70" />
          </div>
          <div className="relative z-10 px-4 md:px-6 lg:px-8 py-12 md:py-20 max-w-7xl mx-auto text-center">
            <h1 className="text-3xl md:text-4xl lg:text-5xl font-bold text-white mb-3 md:mb-4">
              关于黑料在线
            </h1>
            <p className="text-sm md:text-base text-white/70 max-w-2xl mx-auto leading-relaxed">
              专业的娱乐爆料聚合平台，每日精选全网热门八卦，让吃瓜群众永不落伍
            </p>
          </div>
        </div>

        <div className="px-4 md:px-6 lg:px-8 py-6 md:py-8 max-w-4xl mx-auto">
          <Breadcrumb items={breadcrumbItems} />
        </div>

        {/* Brand Story */}
        <section className="px-4 md:px-6 lg:px-8 py-8 md:py-12 max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8 md:gap-12 items-center mb-12 md:mb-16">
            <div>
              <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-4">
                品牌故事
              </h2>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                黑料在线成立于2023年，是一个专注于娱乐八卦、网红爆料、社会热点聚合的内容平台。我们的初衷很简单：在这个信息爆炸的时代，为吃瓜群众筛选出最有料、最真实、最劲爆的爆料内容。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed mb-4">
                从最初的个人博客，到如今覆盖六大频道的专业爆料平台，黑料在线始终坚持"真实、及时、深度"的内容理念。我们不生产瓜，只是全网大瓜的搬运工和筛选机。
              </p>
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                经过三年的发展，黑料在线已累计发布超过一万篇精选爆料文章，月均阅读量突破五百万，成为中文互联网最具人气的娱乐爆料入口之一。
              </p>
            </div>
            <div className="rounded-xl overflow-hidden aspect-[4/3]">
              <img
                src="https://readdy.ai/api/search-image?query=Modern%20creative%20office%20workspace%20with%20warm%20ambient%20lighting%2C%20team%20collaboration%20atmosphere%2C%20dark%20elegant%20interior%20design%2C%20red%20and%20gold%20accent%20decorations%2C%20professional%20photography%20with%20soft%20shadows&width=600&height=450&seq=about-story&orientation=landscape"
                alt="黑料在线团队"
                className="w-full h-full object-cover object-top"
                width={600}
                height={450}
              />
            </div>
          </div>

          {/* Values */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 md:mb-8 text-center">
              我们的价值观
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
              <div className="p-5 md:p-6 rounded-xl bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-primary-100 flex items-center justify-center text-primary-600">
                  <i className="ri-shield-check-line text-xl" />
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-2">
                  真实为本
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  所有爆料均来自公开渠道或可靠知情人，我们尽最大努力核实信息来源，拒绝传播毫无依据的谣言。
                </p>
              </div>
              <div className="p-5 md:p-6 rounded-xl bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-accent-100 flex items-center justify-center text-accent-600">
                  <i className="ri-flashlight-line text-xl" />
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-2">
                  速度致胜
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  7×24小时不打烊更新，重大爆料第一时间推送，确保吃瓜群众永远站在信息第一线。
                </p>
              </div>
              <div className="p-5 md:p-6 rounded-xl bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-4 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-600">
                  <i className="ri-eye-line text-xl" />
                </div>
                <h3 className="text-base font-bold text-foreground-900 mb-2">
                  深度挖掘
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed">
                  不止于表面爆料，更致力于深度扒皮和内幕追踪，让每一条大瓜都有来龙去脉。
                </p>
              </div>
            </div>
          </div>

          {/* Platform Reputation */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 md:mb-8 text-center">
              平台声誉
            </h2>
            <div className="p-5 md:p-6 rounded-xl bg-background-100">
              <div className="grid grid-cols-2 md:grid-cols-4 gap-4 md:gap-6 mb-6 md:mb-8">
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                    10,000+
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500">
                    精选爆料文章
                  </p>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                    500万+
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500">
                    月均阅读量
                  </p>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                    6
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500">
                    爆料分类频道
                  </p>
                </div>
                <div className="text-center">
                  <div className="text-2xl md:text-3xl font-bold text-primary-500 mb-1">
                    98%
                  </div>
                  <p className="text-xs md:text-sm text-foreground-500">
                    用户满意度
                  </p>
                </div>
              </div>
              <p className="text-sm text-foreground-500 leading-relaxed text-center max-w-2xl mx-auto">
                黑料在线自成立以来，始终坚持高质量内容输出，在娱乐爆料领域建立了良好的口碑。我们的内容被多家主流媒体转载引用，成为行业内的重要信息参考来源。
              </p>
            </div>
          </div>

          {/* FAQ */}
          <div className="mb-12 md:mb-16">
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 md:mb-8 text-center">
              常见问题
            </h2>
            <div className="space-y-3">
              {[
                {
                  q: "黑料在线的内容来源可靠吗？",
                  a: "我们所有内容均来自公开渠道报道、社交媒体信息以及知情人士的爆料。对于重要爆料，我们会进行多源交叉验证，力求信息的真实性和准确性。但我们无法保证所有内容100%准确，部分内容仅供娱乐参考。",
                },
                {
                  q: "如何向黑料在线投稿爆料？",
                  a: "如果您有独家爆料信息，可以通过本页底部的联系方式与我们取得联系。请尽量提供详细的信息描述、相关证据（照片、截图、录音等）以及您的联系方式。我们承诺对爆料人身份严格保密。",
                },
                {
                  q: "黑料在线是否侵犯他人隐私？",
                  a: "我们只报道公众人物在公共场合的行为和已经公开的信息，不涉及私人住宅偷拍、非法窃听等侵犯隐私的行为。如果我们的报道侵犯了您的合法权益，请通过官方渠道联系我们，我们将第一时间处理。",
                },
                {
                  q: "黑料在线是否收取费用？",
                  a: "黑料在线的所有内容均免费向读者开放。我们不向读者收取任何费用，也不出售用户数据。网站的运营成本主要通过合法的广告收入来维持。",
                },
              ].map((faq, index) => (
                <details
                  key={index}
                  className="rounded-xl bg-background-100 border border-background-200/40 overflow-hidden group"
                >
                  <summary className="flex items-center justify-between p-4 md:p-5 text-left cursor-pointer list-none">
                    <span className="text-sm md:text-base font-semibold text-foreground-900 pr-4">
                      {faq.q}
                    </span>
                    <i className="ri-arrow-down-s-line text-lg text-foreground-400 flex-shrink-0 transition-transform group-open:rotate-180" />
                  </summary>
                  <div className="px-4 md:px-5 pb-4 md:pb-5">
                    <p className="text-sm text-foreground-500 leading-relaxed">
                      {faq.a}
                    </p>
                  </div>
                </details>
              ))}
            </div>
          </div>

          {/* Contact */}
          <div>
            <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-6 md:mb-8 text-center">
              联系我们
            </h2>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 md:gap-6">
              <div className="p-5 md:p-6 rounded-xl bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-primary-100 flex items-center justify-center text-primary-600">
                  <i className="ri-mail-line text-xl" />
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">
                  商务合作
                </h3>
                <p className="text-sm text-foreground-500">hello@lvepkfa.cn</p>
              </div>
              <div className="p-5 md:p-6 rounded-xl bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-accent-100 flex items-center justify-center text-accent-600">
                  <i className="ri-feedback-line text-xl" />
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">
                  投稿爆料
                </h3>
                <p className="text-sm text-foreground-500">hello@lvepkfa.cn</p>
              </div>
              <div className="p-5 md:p-6 rounded-xl bg-background-100 text-center">
                <div className="w-12 h-12 mx-auto mb-3 rounded-full bg-secondary-100 flex items-center justify-center text-secondary-600">
                  <i className="ri-customer-service-line text-xl" />
                </div>
                <h3 className="text-sm font-bold text-foreground-900 mb-1">
                  用户反馈
                </h3>
                <p className="text-sm text-foreground-500">hello@lvepkfa.cn</p>
              </div>
            </div>

            {/* Contact Form */}
            <div className="mt-6 md:mt-8 p-5 md:p-6 rounded-xl bg-background-100 border border-background-200/40">
              <h3 className="text-lg font-bold text-foreground-950 mb-4">
                给我们留言
              </h3>
              <form
                onSubmit={(e) => {
                  e.preventDefault();
                }}
                className="grid grid-cols-1 sm:grid-cols-2 gap-4"
              >
                <input
                  type="text"
                  name="name"
                  placeholder="您的姓名"
                  required
                  className="px-3 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-800 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
                />
                <input
                  type="email"
                  name="email"
                  placeholder="您的邮箱"
                  required
                  className="px-3 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-800 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400"
                />
                <textarea
                  name="message"
                  placeholder="请输入您的留言内容..."
                  required
                  maxLength={500}
                  rows={4}
                  className="sm:col-span-2 px-3 py-2.5 rounded-lg bg-background-50 border border-background-200 text-foreground-800 text-sm placeholder:text-foreground-400 focus:outline-none focus:border-primary-400 resize-none"
                />
                <input
                  type="text"
                  name="website_alt"
                  tabIndex={-1}
                  autoComplete="off"
                  aria-hidden="true"
                  readOnly
                  className="hp-field"
                />
                <div className="sm:col-span-2 flex justify-end">
                  <button
                    type="submit"
                    className="px-6 py-2.5 bg-primary-500 text-background-50 rounded-full text-sm font-semibold hover:bg-primary-600 transition-colors whitespace-nowrap cursor-pointer"
                  >
                    提交留言
                  </button>
                </div>
              </form>
            </div>
          </div>
        </section>
      </main>

      <Footer />
    </div>
  );
}
